import { createAsyncSelectors } from '@lib/selectors';
import { ExportButton } from '@ui/general/ExportButton';
import React from 'react';

import { coreActions, PostDataSecurityAccessExplainerExportRequest } from '@sonar-software/sonar-core';

export interface AccessExplainerExportButtonProps {
	queryParams: PostDataSecurityAccessExplainerExportRequest;
}

export const exportStartSelectors =
createAsyncSelectors((state) => state.core.dataSecurity.dataAccess.accessExplainer.export.post);


export const AccessExplainerExportButton: React.FC<AccessExplainerExportButtonProps> = ({ queryParams }) =>
	<ExportButton
		buttonProps={ {
			id: 'access-explainer-export-button',
			type: 'primary'
		} }
		onStartExport={ coreActions.requestPostCoreDataSecurityAccessExplainerExport }
		request={ queryParams }
		resetExport={ coreActions.resetPostCoreDataSecurityAccessExplainerExport }
		stateSelector={ exportStartSelectors.state } />;

